import React from "react";
import styled from "styled-components";
import { GridColumn, Icon } from "../";
export const ModalSmall = ({
  open = false,
  setOpen,
  children,
  ...props
}) => {
  return React.createElement(DropShadow, {
    open: open
  }, React.createElement(ModalContainer, props, React.createElement(CloseIcon, {
    onClick: () => {
      setOpen(false);
    },
    platform: true,
    name: "Close"
  }), !!open && children));
};
const DropShadow = styled(GridColumn)`
  background: rgba(0,0,0,.38);
  height: 100%;
  position: fixed;
  top: 0;
  right: 0%;
  bottom: 0;
  left: 0;
  transition: all ease .3s;
  width: 100%;
  z-index: 499;
  opacity: ${props => props.open ? 1 : 0};
  visibility: ${props => props.open ? "visible" : "hidden"};
`;
const ModalContainer = styled(GridColumn)`
  align-self: center;
  background-color: #fff;
  box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.24), 0 0 8px 0 rgba(0, 0, 0, 0.32);
  height: 456px;
  margin-top: 72px;
  padding: 32px 40px 40px 40px;
  position: fixed;
  width: 680px;
  z-index: 500;
`;
const CloseIcon = styled(Icon)`
  cursor: pointer;
  position: absolute;
  right: 40px;
  top: 32px;
`;